import { siteInfo, heroStats } from '@/mocks/homeData';

export default function Hero() {
  const handleCTA = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative w-full overflow-hidden bg-gradient-to-br from-background-100 via-background-50 to-primary-50/30"
    >
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-background-50/80 z-[1]"></div>

      <div className="relative z-[2] w-full px-4 md:px-6 pt-[120px] pb-16 md:pb-20">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-primary-100/80 rounded-full mb-6">
              <i className="ri-sparkling-2-line text-primary-500 text-sm"></i>
              <span className="text-xs font-medium text-primary-700 whitespace-nowrap">每日更新 · 秒开不缓冲</span>
            </div>

            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-tight mb-4">
              久播影院
              <span className="block text-2xl md:text-3xl lg:text-4xl font-medium text-foreground-700 mt-2">
                高清电视剧全集免费在线观看
              </span>
            </h1>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8 max-w-xl lg:max-w-none mx-auto lg:mx-0">
              {siteInfo.intro}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              {heroStats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-xl md:text-2xl font-bold text-primary-500 font-heading">
                    {stat.value}
                  </div>
                  <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#media"
                onClick={(e) => handleCTA(e, '#media')}
                className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg"></i>
                开始追剧
              </a>
              <a
                href="#ranking"
                onClick={(e) => handleCTA(e, '#ranking')}
                className="inline-flex items-center gap-2 px-8 py-3 border-2 border-background-300 hover:border-primary-300 text-foreground-700 hover:text-primary-600 font-medium text-sm rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line text-lg"></i>
                查看热播榜
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[500px] aspect-[4/3] rounded-2xl overflow-hidden bg-background-200">
              <img
                src={siteInfo.heroImageUrl}
                alt="久播影院 - 高清电视剧在线观看平台主视觉"
                className="w-full h-full object-cover"
                onError={(e) => {
                  (e.target as HTMLElement).style.display = 'none';
                }}
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-primary-500/10 via-transparent to-accent-500/10"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}